const MAGIC = new Uint8Array([0x56, 0x42, 0x45, 0x31]);
const AAD = new TextEncoder().encode('vorbello-conference-data-v1');

export async function importConferenceDataKey(key: Uint8Array): Promise<CryptoKey> {
  if (key.byteLength !== 32) throw new Error('Cheie de conferință invalidă.');
  return crypto.subtle.importKey('raw', new Uint8Array(key), { name: 'AES-GCM' }, false, ['encrypt', 'decrypt']);
}

export async function encryptConferenceData(key: CryptoKey, payload: Uint8Array): Promise<Uint8Array> {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const ciphertext = new Uint8Array(await crypto.subtle.encrypt({ name: 'AES-GCM', iv, additionalData: AAD }, key, new Uint8Array(payload)));
  const packet = new Uint8Array(MAGIC.length + iv.length + ciphertext.length);
  packet.set(MAGIC); packet.set(iv, MAGIC.length); packet.set(ciphertext, MAGIC.length + iv.length);
  return packet;
}

export async function decryptConferenceData(key: CryptoKey, packet: Uint8Array): Promise<Uint8Array> {
  if (packet.length < 32 || !MAGIC.every((value, i) => packet[i] === value)) throw new Error('Date necriptate sau invalide.');
  const iv = packet.slice(4, 16), ciphertext = packet.slice(16);
  return new Uint8Array(await crypto.subtle.decrypt({ name: 'AES-GCM', iv, additionalData: AAD }, key, ciphertext));
}
